"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = require("react");

var _FeatureToggleContext = _interopRequireDefault(require("./FeatureToggleContext"));

var useFeatureToggle = function useFeatureToggle(conditions) {
  var attributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var results = false;
  var context = (0, _react.useContext)(_FeatureToggleContext["default"]);
  return (0, _react.useMemo)(function () {
    if (context) {
      if (Array.isArray(conditions)) {
        results = conditions.reduce(function (ft, condition) {
          // Skip second parameter - accountId
          ft[condition] = context.isEnabled.apply(context, [condition].concat([,], [attributes]));
          return ft;
        }, {});
      } else {
        results = context.isEnabled.apply(context, [conditions].concat([,], [attributes]));
      }
    }

    return [!context, results];
  }, [context, conditions, JSON.stringify(attributes)]);
};

var _default = useFeatureToggle;
exports["default"] = _default;